import { Deserializable } from '../protocols/deserializable';
import { BaseType } from '../base/base-type';
import { MonthlyPensionAnnuityTypeIdEnum } from '../enum/shared/monthly-pension-annuity-type-id.enum';

export class MonthlyPensionAnnuitySurvivorBenefitType extends BaseType implements Deserializable {
  public declare id: MonthlyPensionAnnuityTypeIdEnum;
  public value!: number;
  public archived!: boolean;

  public onDeserialize(): void {}
}
